export function getSafe(fn)
{
    try
    {
        return fn()
    }
    catch (e)
    {
        return undefined
    }
}



// WEBPACK FOOTER //
// ./src/scripts/utils/Object.js